export const enum SubscriptionTier {
    Trial = 'TRIAL',
    Pro = 'PRO',
}
